import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
  inject,
  output,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ComponentConfig } from '../../cockpitComponents';
import { DesignCockpitComponentList } from '../designerCockpitsList/design.cockpit.list.component';
import { DropListRegistryService } from '../drop-list-registry.service';
import { CdkDropList } from '@angular/cdk/drag-drop';
import { DesignerRowEditor } from '../deisgnerRowEditor/designer-row-editor.component';
import {
  DesignerCSSPropertiesForm,
  ElementProperties,
} from '../designerCSSPropertiesForm/designerCSSPropertiesForm';
import { CockpitDesignerStore } from '../cockpitDesigner.service';
import {  computed } from '@angular/core';
import { defaultRowElementProperties } from '../designer.constants';
import { CockpitDesignerVideoOptions } from '../videoOptions/video-options.component';
import { GridComponent, videoProperties } from '../cockpitDesigner.models';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Device } from '../../bots/bots.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DesignerComponentSettings } from  '../componentSettings/component.settings.component';

@Component({
  selector: 'app-design-sidebar',
  templateUrl: 'design.sidebar.component.html',
  styleUrl: 'design.sidebar.component.css',
  imports: [
    MatTabsModule,
    DesignCockpitComponentList,
    DesignerRowEditor,
    DesignerCSSPropertiesForm,
    DesignerComponentSettings,
    CockpitDesignerVideoOptions,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  standalone: true,
})
export class DesignSidebar implements OnInit, AfterViewInit {
  private registry = inject(DropListRegistryService);
  @ViewChild(CdkDropList) sidebarList!: CdkDropList;
  @Input() components: ComponentConfig[] = [];
  @Input() devices: Device[] = [];
  @Input() selectedComponent: {gridComponent: GridComponent, rowId: string, columnId: string} | null = null;
  pushButtonIdChange = output<string>();
  pushButtonNameChange = output<string>();
  handleComponentChange = output<{gridComponent:GridComponent, rowId: string, columnId:string}>();
  closeComponentSettings = output();
  
  private readonly store = inject(CockpitDesignerStore);
  onSave = output();
  assignedDevicesChange = output<string[]>();
  assignedDeviceIds = this.store.assignedDeviceIDs;

  formTouched = this.store.touched;
  selectedId = this.store.selectedRowId;
  currentVideoConfig = this.store.videoConfig;
  currentProperties = computed(
    () =>
      this.store.rows().find((item) => this.selectedId() === item.id)?.properties ??
      defaultRowElementProperties,
  );
  ngOnInit() {
    console.log('components (ngOnInit) sidebar', this.components);
  }

  ngAfterViewInit() {
    this.registry.register(this.sidebarList);
  }

  handlePropertiesChange(event: ElementProperties) {
    const selectedId = this.selectedId();
    if (selectedId != null) {
      this.store.updateRowProperties(selectedId, event);
    }
  }

  handleColumnChange(event: number) {
    this.store.updateColumns(event);
  }

  handleVideoOptionsChange(event: videoProperties) {
    this.store.updateVideoConfigProperties(event);
  }

  handleAssignedBotsChange(event: any) {
    this.assignedDevicesChange.emit(event.value)
  }

  handleSaveChanges() {
    this.onSave.emit();
  }

  onCloseComponentSettings(){
    this.closeComponentSettings.emit()
  }

  handlePushButtonNameChange(event:string){
    this.pushButtonIdChange.emit(event);
  }

   handlePushButtonIdChange(event:string){
    this.pushButtonIdChange.emit(event);
  }

  componentChange(event:GridComponent){
    if(!this.selectedComponent) return null;
    this.handleComponentChange.emit({gridComponent:event, rowId:this.selectedComponent?.rowId, columnId:this.selectedComponent?.columnId});
    console.log('new componet in desgin ber', event)
    return;
  }
}
